module.exports = __webpack_public_path__ + "img/program_example_rune.215430c5.png";